import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesPreview() {
  const preview = articles.slice(0, 3);
  return (
    <section id="articles" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
              <i className="ri-newspaper-line" /> 追更资讯
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950">最新资讯与追更攻略</h2>
            <p className="mt-2 text-sm text-foreground-600">新番盘点、追更技巧、行业专访，一文全掌握</p>
          </div>
          <Link
            to="/article/1"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            查看全部资讯 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {preview.map((a) => (
            <Link
              key={a.id}
              to={`/article/${a.id}`}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={a.cover}
                  alt={a.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {a.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="line-clamp-2 text-sm font-bold leading-relaxed text-foreground-950 group-hover:text-primary-700">
                  {a.title}
                </h3>
                <p className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                  <span>{a.author}</span>
                  <span className="h-3 w-px bg-background-300" />
                  <span>{a.date}</span>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}